import builder from '../builder';
import SingleNeutral from '../../streamline-icons/light/single-neutral.svg';

export default builder('IconSingleNeutralLight', SingleNeutral);
